import { render, staticRenderFns } from "./StarShopActivityLog.vue?vue&type=template&id=cdb670d4"
import script from "./StarShopActivityLog.vue?vue&type=script&lang=js"
export * from "./StarShopActivityLog.vue?vue&type=script&lang=js"
import style0 from "./StarShopActivityLog.vue?vue&type=style&index=0&id=cdb670d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports